require('./style.scss');

import EventEmmiter from 'lib/helpers/EventEmmiter';
import E3Select from 'lib/ui/e3-select/e3-select';
import {unit} from 'lib/e3plan-3d/modules/libs/measurementTool';

const cloneDeep = require('lodash/cloneDeep');

export default class Index extends EventEmmiter {
    _controls = {};
    _wrapper = null;
    _container = null;

    constructor(container, config = {}) {
        super();
        this._config = cloneDeep(config);
        this._container = container;

        this._init();
        this._initControlls();
        this._initUnitSelect();
    }

    _init() {
        this._wrapper = document.createElement('div');
        this._wrapper.classList.add('e3-measurement-panel');

        this._wrapper.innerHTML = require('./template.html');
        this._container.appendChild(this._wrapper);
        this._text();
    }

    _text(){
        let title = this._container.querySelector('.e3-measurement-panel__title');
        title.textContent = this._config.translate('MEASUREMENT_TITLE');

        let disclaimer = this._container.querySelector('.e3-measurement-panel__disclaimers');
        disclaimer.textContent = this._config.translate('MEASUREMENT_DISCLAIMER');
    }

    _initControlls(){
        let remove = this._container.querySelector('.e3-measurement-panel__header__btn_remove');
        this._initControl({
            name: 'remove',
            element: remove,
            event: 'click',
            callback: this._toggleControl.bind(this, 'remove', true)
        });

        let add = this._container.querySelector('.e3-measurement-panel__header__btn_add');
        this._initControl({
            name: 'add',
            element: add,
            event: 'click',
            callback: this._toggleControl.bind(this, 'add', true)
        });

        let close = this._container.querySelector('.e3-measurement-panel__header__btn_close');
        this._initControl({
            name: 'close',
            element: close,
            event: 'click',
            callback: this._toggleControl.bind(this, 'close', true)
        });
    }

    _initControl({name, element, event = 'click', callback = () => true}) {
        let control = {
            value: false,
            element,
            events: {}
        };

        control.events[event] = callback;

        this._controls[name] = control;
        this._bindControlListeners(name);
    }

    _bindControlListeners(name) {
        let control = this._controls[name];
        if (!control) return;
        for (let i in control.events) {
            if (control.events.hasOwnProperty(i)) {
                control.element.addEventListener(i, control.events[i]);
            }
        }
    }

    _unbindControlListeners(name) {
        let control = this._controls[name];
        for (let i in control.events) {
            if (control.events.hasOwnProperty(i)) {
                control.element.removeEventListener(i, control.events[i]);
            }
        }
    }

    _destroyControl(name) {
        this._unbindControlListeners(name);
        this._controls[name].element.parentElement.removeChild(this._controls[name].element);
        delete this._controls[name];
    }

    _initUnitSelect() {
        let coff = null;
        const list = Object.values(unit).map((data) => {
            if(data.current) coff = data.coff;

            return {
                name: data.name,
                value: data.coff
            }
        })
        
        const selectContainer = document.createElement('div');
        selectContainer.classList.add('select-container');
        this._wrapper.querySelector('.e3-measurement-panel__select').appendChild(selectContainer);

        const metricSelect = new E3Select(
            selectContainer,
            {
                initValue: coff,
                className: ['e3plan-unit-select']
            },
            list
        );

        metricSelect.on('set.value', (e) => {
            this._fireEvent('set.unit', e);
        });

        return metricSelect;
    }

    _toggleControl(name, val, event) {
        event.preventDefault();
        event.stopPropagation();

        let control = this._controls[name];
        if (!control) return;
        control.value = typeof val !== 'undefined' ? val : !control.value;
        this._fireEvent(name, control.value);
    }

    toggleButton(type, action) {
        this._controls[type].element.classList[action]('hidden');
    }

    toggleLabel(show) {
        let label = this._wrapper.querySelector('.e3-measurement-panel__title');
        label.classList[show]('hidden');
    }

    show(){
        if(this._wrapper.classList.contains('hidden')) this._wrapper.classList.remove('hidden')
    }

    hide(){
        if(!this._wrapper.classList.contains('hidden')) this._wrapper.classList.add('hidden')
    }

    destroy() {
        for (let i in this._controls) {
            if (this._controls.hasOwnProperty(i)) {
                this._destroyControl(i);
            }
        }
        this._container.removeChild(this._wrapper);
    }
}
